import React, { FC } from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import { LedLargeLogoIcon } from 'assets/svgs/led';
import { LedMenu } from 'containers/led/layouts';
import { PageLink } from 'components/common/atoms';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      margin: 0,
      paddingRight: 300,
      position: 'relative',
      height: 'auto',
      minHeight: '100vh',
      display: 'none',
      [theme.breakpoints.up('lg')]: {
        display: 'block',
      },
    },
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      width: 300,
      height: '100%',
      backgroundColor: theme.palette.background.paper,
      zIndex: 1,
    },
    logo: {
      padding: theme.spacing(8, 0, 21, 5),
    },
  })
);

const LedDesktopNavigation: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.root}>
        <Box className={classes.logo}>
          <PageLink href="/" aria-label={'Theme Logo'}>
            <LedLargeLogoIcon />
          </PageLink>
        </Box>
        <LedMenu />
      </Box>
    </Box>
  );
};

export default LedDesktopNavigation;
